import { SET_SNAG_PROJECTS } from './types';

export const setSnagProjects = (projects) => ({
    type: SET_SNAG_PROJECTS,
    payload: projects,
});
